import {
  IndexProps,
  InstantSearchProps,
  Index as OriginalIndex,
  InstantSearch as OriginalInstantSearch,
} from "react-instantsearch";

import { withStagingAlgoliaPrefixIndex } from "@/lib/utils";

export const Index: React.FC<IndexProps> = ({ indexName, ...props }) => {
  const prefixedIndexName = withStagingAlgoliaPrefixIndex(indexName);

  return <OriginalIndex indexName={prefixedIndexName} {...props} />;
};

export const InstantSearch: React.FC<InstantSearchProps> = ({
  indexName,
  ...props
}) => {
  let prefixedIndexName = indexName;
  if (indexName && typeof indexName === "string") {
    prefixedIndexName = withStagingAlgoliaPrefixIndex(indexName);
  }

  return <OriginalInstantSearch indexName={prefixedIndexName} {...props} />;
};
